import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LuLoaderCircle } from 'react-icons/lu';
import { useGoogleLogin } from '@react-oauth/google';
import { useContextHook } from 'use-context-hook';
import AuthLayout from '../AuthLayout';
import GoogleIcon from '../AuthLayout/GoogleIcon';
import AuthField from '../AuthLayout/AuthField';
import {
  AuthFormShell,
  AuthSubtitle,
  AuthTitle,
  Divider,
  ForgotLink,
  SocialButton,
  SocialButtons,
  Spinner,
  SubmitButton,
  SwitchText,
} from '../AuthLayout/AuthLayout.styles';
import Form, { useForm } from '../../molecules/Form';
import { AuthContext } from '../../../Context/authContext';

function Login() {
  const [form] = useForm();
  const navigate = useNavigate();

  const { onLogin, loading_user, onGoogleLogin, loading_user_google } = useContextHook(AuthContext, v => ({
    onLogin: v.onLogin,
    loading_user: v.loading_user,
    onGoogleLogin: v.onGoogleLogin,
    loading_user_google: v.loading_user_google,
  }));

  const handleSubmit = e => {
    onLogin(
      {
        email: e?.email,
        password: e?.password,
      },
      navigate,
    );
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async tokenResponse => {
      const { access_token } = tokenResponse;
      onGoogleLogin({ access_token, action: 'Login' });
    },
  });

  return (
    <AuthLayout>
      <AuthTitle>Welcome back</AuthTitle>
      <AuthSubtitle>Sign in to pick up where your agent left off.</AuthSubtitle>

      <SocialButtons>
        <SocialButton type="button" onClick={googleLogin} disabled={loading_user_google}>
          {loading_user_google ? (
            <Spinner>
              <LuLoaderCircle />
            </Spinner>
          ) : (
            <GoogleIcon />
          )}
          Continue with Google
        </SocialButton>
      </SocialButtons>

      <Divider>
        <span>or</span>
      </Divider>

      <AuthFormShell>
        <Form form={form} onSubmit={handleSubmit}>
          <Form.Item
            label="Work email"
            type="email"
            name="email"
            placeholder="you@company.com"
            rules={[{ required: true, message: 'Email is required' }]}>
            <AuthField />
          </Form.Item>

          <Form.Item
            label="Password"
            type="password"
            name="password"
            placeholder="Your password"
            rules={[{ required: true, message: 'Password is required' }]}>
            <AuthField />
          </Form.Item>

          <ForgotLink to="/forgot-password">Forgot password?</ForgotLink>

          <SubmitButton type="submit" disabled={loading_user}>
            {loading_user && (
              <Spinner>
                <LuLoaderCircle />
              </Spinner>
            )}
            Sign in
          </SubmitButton>
        </Form>
      </AuthFormShell>

      <SwitchText>
        New to Tigaly? <Link to="/sign-up">Create an account</Link>
      </SwitchText>
    </AuthLayout>
  );
}

export default Login;
